import { firestoreAction } from 'vuexfire'
import {db} from '@/firebase'

const state = {
  banners: []
}

const getters = {
  getBanners: state => state.banners  
}

const actions = {
  setBannerRef: firestoreAction(({ bindFirestoreRef }, { ref }) => {
    bindFirestoreRef('banners', ref, db.collection('banners').where('status', '==', 1))
  })
}

export default {
  namespaced: true,
  state,
  getters,
  actions
}

